import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReferenceBox from '../../common/reference-box';
import articleTagsService from '../../../services/article-tags/article-tags';
import './recommended-article-box.css';

class RecommendedArticleBox extends Component {
  
  render() { 
    const relevantTags = articleTagsService.getRelevantRecommendationsTags(this.props.tags);

    return (
      <div className='recommended-article-box little-grow-animation'>
        <ReferenceBox 
          link={this.props.url} 
          isExternalResource={true}
          _id={this.props._id}
          title={this.props.title}
          date={this.props.date}
          tags={relevantTags}
          url={this.props.url}
          imgSrc={this.props.imgSrc}
          readMinutes={this.props.readMinutes}
          level={this.props.level}
          writer={this.props.writer}
          publication={this.props.publication}
          buffText={this.props.buffText} />
      </div>
    );
  }
}

RecommendedArticleBox.propTypes = {
  _id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  url: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  readMinutes: PropTypes.string,
  level: PropTypes.number,
  writer: PropTypes.string, 
  publication: PropTypes.string,
  buffText: PropTypes.string
};

export default RecommendedArticleBox;